module.exports = __webpack_public_path__ + "static/redtarn-mtcook-22c2f5f7252232f03ddf4af40a0632d2.jpg";